/**
 * useStatusInitialization - Initialize status service for real-time status updates
 */
import { useEffect } from 'react'
import { dia } from '@joint/core'
import { statusService, useStatusStore } from '../../../../../map-editor-features/status'
import { useFloorStore } from '../../../../../map-editor-shared/store/floorStore'

interface UseStatusInitializationParams {
  graph: dia.Graph | null
  elementCount: number
}

export function useStatusInitialization({ graph, elementCount }: UseStatusInitializationParams) {
  const { connect, disconnect } = useStatusStore()

  useEffect(() => {
    if (!graph) return

    const elements = graph.getElements()

    const cctvIds = elements
      .filter(el => {
        const type = el.get('type') || el.get('objectType')
        return type === 'Cctv' || type === 'cctv'
      })
      .map(el => String(el.id))

    const parkingIds = elements
      .filter(el => {
        const type = el.get('type') || el.get('objectType')
        return type === 'ParkingLocation' || type === 'parkingLocation'
      })
      .map(el => String(el.id))

    const currentFloorId = useFloorStore.getState().currentFloor || 'editor-floor'
    statusService.initialize([{
      floorId: currentFloorId,
      cctvIds,
      parkingIds,
    }])

    connect()

    return () => {
      disconnect()
    }
  }, [graph, elementCount, connect, disconnect])
}
